<template>
    <section class="log-in-dlg">
        <app-confirmation title="Log In"
                          class="log-in-dlg__confirmation"
                          confirm-text="Continue"
                          confirm-icon-class="fas fa-sign-in-alt"
                          confirm-button-type="cta"
                          @cancel="onCancel"
                          @confirm="onLogIn">
            <p class="log-in-dlg__confirmation__text">
                Logging into the application with an existing account will clear any changes that you have made so far and replace them with your previously saved changes. Are you sure you want to do this?
            </p>
        </app-confirmation>
    </section>
</template>

<script>

import AppConfirmation from '../../app-core/app-confirmation'

export default {

    methods: {

        onCancel(ev) {
            this.$eventbus.$emit(this.$appevents.hideModalWithoutActions, ev)
        },

        onLogIn(ev) {
            this.$eventbus.$emit(this.$appevents.hideModalWithoutActions, ev)
            this.$router.push({ name: 'LogIn' })
        },
    },

    components: {
        AppConfirmation,
    },
}

</script>

<style lang="scss">

// Ensure colours and other visual style elements are added to theme files, not placed in here.
// src\scss\schemes\components\auth\modals\_log-in-confirmation.scss

.log-in-dlg {

    @include element('confirmation') {

        @include element('text') {
            text-align: center;
        }
    }

    @include element('buttons') {
        padding-top: 10px;
        width: 100%;
        display: flex;
    }
}

</style>
